import { render, staticRenderFns } from "./VisitorCard.vue?vue&type=template&id=a4d114a2&scoped=true"
import script from "./VisitorCard.vue?vue&type=script&lang=js"
export * from "./VisitorCard.vue?vue&type=script&lang=js"
import style0 from "./VisitorCard.vue?vue&type=style&index=0&id=a4d114a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d114a2",
  null
  
)

export default component.exports